module.exports = __webpack_public_path__ + "media/images/emblems/Sales_Blason-ab25be9e103bd3fe786f366a45aba445.png";